import React, { useContext } from 'react';
import classnames from 'classnames';
import { MarkupContext } from '../../../contexts';
import OpacitySlider from '../sliders/opacitySlider';
import RegionsMapper from './regionsMapper';
import ImageMarkups from './imageMarkups';

const LeftPartWithImage = () => {
  const { tab, createMode, updateCreateMode } = useContext(MarkupContext);

  const handleActiveButtonChange = (event) => {
    updateCreateMode(event.target.value !== 'select');
  };

  return (
    <div className={ classnames("summary-markup_reactions_image", { '-offset-top': !tab }) } >
      <div className="survey-reactions-interface_wrapper">
        <div className="survey-reactions-interface_image-wrapper">
          { !tab && <RegionsMapper /> }
          <ImageMarkups />
        </div>
      </div>
      {
        !tab &&
        <>
          <div className="survey-reactions-interface_toggle">
            <div className="button-group -inline -sm">
              <input
                id="mode1"
                type="radio"
                name="mode"
                value="select"
                checked={ !createMode }
                onChange={ handleActiveButtonChange }
              />
              <label className="-with-icon" htmlFor="mode1">
                <svg className="icon -i-select-reaction">
                  <use xlinkHref="#svg_i-select-reaction" />
                </svg>
                <span>Select Reaction</span>
              </label>
              <input
                id="mode2"
                type="radio"
                name="mode"
                value="create"
                checked={ createMode }
                onChange={ handleActiveButtonChange }
              />
              <label className="-with-icon" htmlFor="mode2">
                <svg className="icon -i-region">
                  <use xlinkHref="#svg_i-region" />
                </svg>
                <span>Create Region</span>
              </label>
            </div>
          </div>
          <OpacitySlider />
        </>
      }
    </div>
  );
};

export default LeftPartWithImage;
